// extracted by mini-css-extract-plugin
export default {"cls1":"News-cls1___c28daac0b39a966dda6","cls2":"News-cls2___f031a05353c795b6aa5 News-cls1___c28daac0b39a966dda6"};